import React from "react";
import Logo from "../../../../assets/icons/logoNew.png";

const Modal = ({ title, content, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/60 backdrop-blur-md animate-fadeIn">
      <div className="modal-container w-80 mx-4 rounded-3xl shadow-2xl transform scale-100 hover:scale-105 transition-all duration-500 animate-slideIn">
        <div className="flex flex-row gap-4 bg-gradient-to-r from-crimson via-crimson/90 to-crimson/80 backdrop-blur-xl rounded-t-3xl text-white justify-start items-center modal-header text-lg font-bold p-6 shadow-xl relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transform -skew-x-12 animate-shimmer"></div>
          <div className="relative z-10 bg-white bg-opacity-20 p-3 rounded-xl backdrop-blur-sm shadow-lg">
            <img className="w-7 h-7" src={Logo} alt="logo" />
          </div>
          <span className="relative z-10">
            {title.toUpperCase()}
          </span>
        </div>
        <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur-xl rounded-b-3xl relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-golden/10 dark:bg-golden/20 rounded-full blur-3xl"></div>
          <div className="relative z-10 flex justify-center modal-body p-8">
            <p className="text-charcoal dark:text-white text-center leading-relaxed font-medium text-base">{content}</p>
          </div>
          <div className="relative z-10 modal-footer pb-8 flex justify-center">
            <button
              className="bg-gradient-to-r from-crimson to-crimson/80 hover:from-crimson/90 hover:to-crimson text-white font-bold py-4 px-10 rounded-2xl shadow-xl hover:shadow-2xl transform hover:-translate-y-2 hover:scale-105 transition-all duration-400 focus:outline-none focus:ring-4 focus:ring-crimson/30 relative overflow-hidden group"
              onClick={onClose}
            >
              <span className="relative z-10">OK</span>
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
